import {Suspense, lazy} from 'react'
import Loader from "../../customs/loader/main"

const Main = lazy(() => import("../../components/settings/Setups/eligibleGuidelines/main"))

const ElectionGuideline = () => {
  return (
        <Suspense fallback={<Loader />}> 
        <Main />
    </Suspense>
    
    
  )
}

export default ElectionGuideline